import { render } from "./Hardwares.vue?vue&type=template&id=6fb81c00"
import script from "./Hardwares.vue?vue&type=script&lang=js"
export * from "./Hardwares.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__